import billingApiModule from '../billingApi.module';

class BillingAccountApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getBillingAccount() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/accounts/self`
        );
    }

    updateBillingAccount(account) {
        return this.apiUtil.putWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/accounts/self`,
            account
        );
    }
}

export default billingApiModule.service(
    'billingAccountApiService',
    BillingAccountApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/account/billingAccountApi.service.js